import { put } from "redux-saga/effects";
import axios from "../axios/axios-invoice";
import axios_gci from '../axios/axios-gci';
import axios_gcib from '../axios/axios-gcib';
import axios_pr from '../axios/axios-pr';
import * as actions from "../actions/invoice";
import { generateInvoiceHTML } from "../../containers/Invoices/InvoiceObj";
import { parseFloatString } from "../../shared/utility";
import { calculateTotalInvoicePicture } from "../../containers/Invoices/InvoiceLogic";
import { renderReportHTML } from "../../containers/PaymentReports/paymentReportsLogic";
import { renderGeneratedPaymentReportLegacyHTML } from "../../containers/PaymentReports/generatedPaymentReportLegacyHTML";
import {
    getSimulationValidationError,
    paymentReportRequestConfig
} from "../../containers/PaymentReports/paymentReportGeneration";

export function* getInvoiceEntriesSaga(action) {
    yield put(actions.getInvoiceEntriesStart());
    try {
        if (action.data) {
            if (action.filtersObj) {
                const response = yield axios.get('/entries', {
                    params: {
                        status: action.data,
                        ...action.filtersObj,
                    },
                });
                yield put(actions.getInvoiceEntriesSuccess(response.data));
            } else {
                const response = yield axios.get(`/entries?status=${action.data}`);
                yield put(actions.getInvoiceEntriesSuccess(response.data));
            }
        } else if (action.rs_id) {
            const response = yield axios.get(`/entries?rs_id=${action.rs_id}`);
            yield put(actions.getInvoiceEntriesSuccess(response.data));
        }
    } catch (e) {
        if (e.response) {
            if (e.response.data) {
                return yield put(actions.getInvoiceEntriesFail(e.response.data));
            }
        }
        yield put(actions.getInvoiceEntriesFail(e));
    }
}

export function* createInvoiceEntrySaga(action) {
    yield put(actions.createInvoiceEntryStart());
    try {
        const response = yield axios.post("/entry", action.data);
        yield put(actions.createInvoiceEntrySuccess(response.data));
    } catch (e) {
        if (e.response) {
            if (e.response.data) {
                return yield put(actions.createInvoiceEntryFail(e.response.data));
            }
        }
        yield put(actions.createInvoiceEntryFail(e));
    }
}

export function* updateInvoiceEntrySaga(action) {
    yield put(actions.updateInvoiceEntryStart());
    try {
        const response = yield axios.put("/entry", action.data);
        yield put(actions.updateInvoiceEntrySuccess(response.data));
        // yield put(actions.getInvoiceEntries());
    } catch (e) {
        if (e.response) {
            if (e.response.data) {
                return yield put(actions.updateInvoiceEntryFail(e.response.data));
            }
        }
        yield put(actions.updateInvoiceEntryFail(e));
    }
}

export function* deleteInvoiceEntrySaga(action) {
    yield put(actions.deleteInvoiceEntryStart());
    try {
        const response = yield axios.delete("/entry?id=" + action.data);
        yield put(actions.deleteInvoiceEntrySuccess(response.data));
        // yield put(actions.getInvoiceEntries());
    } catch (e) {
        if (e.response) {
            if (e.response.data) {
                return yield put(actions.deleteInvoiceEntryFail(e.response.data));
            }
        }
        yield put(actions.deleteInvoiceEntryFail(e));
    }
}

export function* getInvoicePdfSaga(action) {
    yield put(actions.getInvoicePdfStart());
    try {
        const response = yield axios.post("/entry/pdf", action.data);
        yield put(actions.getInvoicePdfSuccess(response.data));
    } catch (e) {
        if (e.response) {
            if (e.response.data) {
                return yield put(actions.getInvoicePdfFail(e.response.data));
            }
        }
        yield put(actions.getInvoicePdfFail(e));
    }
}

export function* resendInvoiceEmailSaga(action) {
    yield put(actions.resendInvoiceEmailStart());
    try {
        const response = yield axios.put('/entry/resend_invoice_email', action.data);
        yield put(actions.resendInvoiceEmailSuccess(response.data));
    } catch (e) {
        if (e.response) {
            if (e.response.data) {
              return yield put(actions.resendInvoiceEmailFail(e.response.data));
            }
          }
        yield put(actions.resendInvoiceEmailFail(e));
    }
}

export function* voidInvoicesSaga(action) {
    yield put(actions.voidInvoicesStart());
    try {
        for (let i = 0; i < action.data.length; i++) {
            const data = action.data[i];
            const response = yield axios.put('/entry', data);
            console.log('response voiding invoices', response.data);
        }
        if (action.sendNotificationTo) {
            const notification_response = yield axios.post('/notify', {
                email: action.sendNotificationTo.email,
                type: 'void',
                name: action.sendNotificationTo.name
            });
            console.log('response notification for voiding invoices', notification_response.data);
        }
        yield put(actions.voidInvoicesSuccess('OK'));
    } catch (e) {
        if (e.response) {
            if (e.response.data) {
              return yield put(actions.voidInvoicesFail(e.response.data));
            }
          }
        yield put(actions.voidInvoicesFail(e));
    }
}


export function* getInvoicePaymentsSaga(action) {
    yield put(actions.getInvoicePaymentsStart());
    try {
        console.log('getting invoice payments', action.data);
        if (action.data.invoice_id) {
            const response = yield axios.get('/payments?all=true&invoice_id='+action.data.invoice_id);
            yield put(actions.getInvoicePaymentsSuccess(response.data));
        } else if (action.data.rs_id) {
            const response = yield axios.get('/payments?all=true&rs_id='+action.data.rs_id);
            yield put(actions.getInvoicePaymentsSuccess(response.data));
        }
    } catch (e) {
        if (e.response) {
            if (e.response.data) {
              return yield put(actions.getInvoicePaymentsFail(e.response.data));
            }
          }
        yield put(actions.getInvoicePaymentsFail(e));
    }
}

export function* createInvoicePaymentSaga(action) {
    yield put(actions.createInvoicePaymentStart());
    try {
        console.log('paying', action);
        const response = yield axios.post("/payment", action.data);
        const paymentId = response.data ? response.data.payment_id : null;

        if (paymentId) {
            try {
                const reportResponse = yield axios_pr.get(
                    `/payment_report_preview?payment_id=${paymentId}&require_simulation=1`,
                    paymentReportRequestConfig
                );
                const simulationValidationError = getSimulationValidationError(reportResponse.data);
                if (simulationValidationError) throw new Error(simulationValidationError);
                const htmlContent = renderGeneratedPaymentReportLegacyHTML(reportResponse.data);
                yield axios_pr.post('/payment_reports2', {
                    payment_id: paymentId,
                    html_content: htmlContent,
                    data: {
                        report: reportResponse.data,
                        payment_id: paymentId,
                        invoice_id: action.data.invoice_id,
                        rs_id: action.data.rs_id
                    }
                }, paymentReportRequestConfig);
            } catch (reportError) {
                console.log('Could not save generated payment report history', reportError);
            }
        }

        // process GCIB 
        // const dat = action.data;
        // const payment_id = response.data.insertId;
        // const obj = {
        //     invoice_id: dat.invoice_id,
        //     payment: parseFloatString(dat.payment_amount),
        //     payment_date: dat.payment_date,
        //     payment_id: response.data.payment_id
        // };
        // console.log('sending this...', obj, response.data);
        // yield axios_gcib.put('/invoice', obj)

        console.log('got here 123');
        // console.log('got here 1');
        // const all_data = calculateTotalInvoicePicture(action.data.rs_id);
        // // create Payment Report 
        // const chosen = {
        //     invoice_ids: [dat.invoice_id],
        //     payment_ids: [payment_id]
        // }
        // console.log('got here 2');
        // const htmlObj = renderReportHTML(all_data, chosen);
        // const { finalHTML, payments_distObj } = htmlObj;
        // const localHTMLData = {
        //     finalData: all_data,
        //     chosen,
        //     htmlContent: finalHTML,
        //     distObj: payments_distObj
        // };
        // console.log('got here 3');
        // yield axios_pr.post('/entry', {
        //     title: `Payment Report from RS#${rs_id} - Invoice(s)# ${chosen.invoice_ids.join(', ')} - Payment(s) ${chosen.payment_ids.join(', ')}`,
        //     rs_id: action.data.rs_id,
        //     json_data: JSON.stringify(localHTMLData)
        // });
        // console.log('got here 4');
        
        const response_payments = yield axios.get('/payments?all=true&invoice_id='+action.data.invoice_id);
        yield put(actions.getInvoicePaymentsSuccess(response_payments.data));
        yield put(actions.createInvoicePaymentSuccess(response.data));
    } catch (e) {
        if (e.response) {
            if (e.response.data) {
                return yield put(actions.createInvoicePaymentFail(e.response.data));
            }
        }
        yield put(actions.createInvoicePaymentFail(e));
    }
}

export function* updateInvoicePaymentSaga(action) {
    yield put(actions.updateInvoicePaymentStart());
    try {
        const response = yield axios.put("/payment", action.data);
        yield put(actions.updateInvoicePaymentSuccess(response.data));
        const response_payments = yield axios.get('/payments?all=true&invoice_id='+action.data.invoice_id);
        yield put(actions.getInvoicePaymentsSuccess(response_payments.data));
    } catch (e) {
        if (e.response) {
            if (e.response.data) {
                return yield put(actions.updateInvoicePaymentFail(e.response.data));
            }
        }
        yield put(actions.updateInvoicePaymentFail(e));
    }
}
